import { HStack, Header, Icon, Pressable, Text, VStack } from '@rbilabs/universal-components';

export const SectionWrapper = Pressable.withConfig({
  marginTop: '$8',
  marginBottom: '$4',
});

export const SectionTitle = Header.withConfig({
  variant: 'headerTwo',
  fontSize: 'xl',
});

export const CardWrapper = HStack.withConfig({
  backgroundColor: Styles.color.white,
  borderRadius: Styles.borderRadius,
  paddingX: '$5',
  paddingY: '$3.5',
  justifyContent: 'space-between',
  alignItems: 'center',
  flex: 1,
  shadow: 0,
});

export const CalendarIcon = Icon.withConfig({
  variant: 'calendar',
  size: 'md',
});

export const ArrowRightIcon = Icon.withConfig({
  variant: 'back',
  size: 'sm',
  style: {
    transform: [{ rotate: '180deg' }],
  },
});

export const DateTimeWrapper = HStack.withConfig({
  flexGrow: 1,
  paddingX: '$4',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const DateWrapper = VStack.withConfig({});

const TextLabel = Text.withConfig({
  variant: 'copyOne',
  fontSize: 'sm',
});

export const DayLabel = TextLabel.withConfig({
  fontWeight: 'bold',
  textTransform: 'capitalize',
});

export const DateLabel = TextLabel.withConfig({
  textTransform: 'capitalize',
});

export const TimeWrapper = HStack.withConfig({
  alignItems: 'center',
  justifyContent: 'flex-end',
});

export const TimeLabel = TextLabel.withConfig({
  fontSize: 'md',
});
